const initialState = {
  isAuthenticated: false,
  activeRequests: [],
  jwtToken: '',
  userData: {},
  redirect: {},
  cities: [],
  paymentInstance: null,
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch (type) {
  case 'APP:SET_JWT_TOKEN':
    if (!action.refresh) localStorage.setItem('tmt-refreshToken', data?.refreshToken);
    localStorage.setItem('tmt-sessionToken', data?.sessionToken);
    localStorage.removeItem('tmt-guestToken');

    return {
      ...state,
      sessionToken: data?.sessionToken,
      ...(!action.refresh && ({ refreshToken: data?.refreshToken })),
      guestToken: '',
      isAuthenticated: true,
    };
  case 'APP:SET_GUEST_JWT_TOKEN':
    localStorage.setItem('tmt-guestToken', data?.guestToken);
    localStorage.removeItem('tmt-refreshToken');
    localStorage.removeItem('tmt-sessionToken');

    return {
      ...state,
      guestToken: data?.guestToken,
      sessionToken: '',
      refreshToken: '',
      isAuthenticated: false,
    };
  case 'APP:REMOVE_JWT_TOKEN':
    localStorage.removeItem('tmt-refreshToken');
    localStorage.removeItem('tmt-sessionToken');
    localStorage.removeItem('tmt-guestToken');

    return {
      ...state,
      sessionToken: '',
      refreshToken: '',
      guestToken: '',
      isAuthenticated: false,
      userData: { isAdmin: false },
    }
  case 'APP:ACTIVE_REQUEST:APPEND':
    return {
      ...state,
      activeRequests: Array.from(state.activeRequests).concat(data),
    };
  case 'APP:ACTIVE_REQUEST:REMOVE':
    const requests = [...state.activeRequests];
    requests.splice(requests.indexOf(data), 1);

    return {
      ...state,
      activeRequests: requests,
    };
  case 'APP:USER_DATA:SET':
    return {
      ...state,
      userData: {
        ...data,
        isAdmin: data?.role === 'admin',
      },
    }
  case 'CITIES_LIST:DATA:SET':
    return {
      ...state,
      cities: data,
    }
  case 'PAYMENT:INSTANCE:SET':
    return {
      ...state,
      paymentInstance: data,
    }
  case 'APP:REDIRECT:SET':
    return {
      ...state,
      redirect: data,
    }
  default:
    return state;
  }
};
